"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CartItem, _Component);

  function CartItem(props) {
    (0, _classCallCheck3.default)(this, CartItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartItem.__proto__ || (0, _getPrototypeOf2.default)(CartItem)).call(this, props));

    _this.removeItem = function (event) {
      event.preventDefault();
      _this.props.removeCartItem(_this.props.item);
    };

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.updateQuantity = _this.updateQuantity.bind(_this);
    _this.state = {
      quantity: props.item.quantity
    };
    return _this;
  }

  (0, _createClass3.default)(CartItem, [{
    key: "render",
    value: function render() {
      var item = this.props.item;
      var quantity = this.state.quantity;

      return _react2.default.createElement(
        "tr",
        { className: "cart-item" },
        _react2.default.createElement(
          "td",
          { className: "cart-item-name" },
          item.name
        ),
        _react2.default.createElement(
          "td",
          { className: "cart-item-quantity" },
          (0, _VoucherUtil.getItemCount)(item),
          " kpl"
        ),
        _react2.default.createElement(
          "td",
          { className: "cart-item-price" },
          (0, _VoucherUtil.totalPriceWithVAT)(item)
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            "button",
            { className: "cart-item-remove remove-js", onClick: this.removeItem },
            "\u2715"
          )
        )
      );
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(event) {
      event.preventDefault();
      this.setState({ quantity: event.target.value });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      event.preventDefault();
      var quantity = parseInt(event.target.value, 10);
      if (isNaN(quantity) || quantity <= 0) {
        quantity = 1;
      }
      this.setState({ quantity: quantity });
      this.props.updateQuantity(this.props.item, quantity);
    }
  }]);
  return CartItem;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object.isRequired,
  removeCartItem: _react.PropTypes.func.isRequired,
  updateQuantity: _react.PropTypes.func.isRequired
}, _temp);
exports.default = CartItem;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/CartItem.js
 ** module id = 1199
 ** module chunks = 0
 **/